import axios from "axios";

const axiosPost = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    // Accept: "application/json",
    "Content-Type": "application/json",
  },
});

axiosPost.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error.response.data.error.message);
  }
);

axiosPost.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 413) {
        const errorMessage =
          "📦 Բովանդակությունը չափազանց մեծ է։ Խնդրում ենք ընտրել փոքր ֆայլ։";
        return Promise.reject(errorMessage);
      }

      const errorMessage = Array.isArray(error.response.data?.error?.message)
        ? error.response.data?.error?.message?.join(" | ")
        : error.response.data?.error?.message ||
          "⚠️ Չհաջողվեց կատարել գործողությունը առկա են տեխնիկական խնդիրներ";

      if (
        errorMessage === "Unauthenticated." ||
        errorMessage === "Unauthorized"
      ) {
        localStorage.clear();

        setTimeout(() => {
          window.location.replace("/login");
        }, 100);
      }

      return Promise.reject(errorMessage);
    } else if (error.request) {
      console.error("Request error", error.request);
    } else {
      console.error("Error", error.message);
    }
    return Promise.reject(error);
  }
);

export default axiosPost;
